<template>
  <div class="promptVersionDeletion">
    <p>
      Êtes-vous sûr de vouloir supprimer<br />la version "{{ versionName }}" ?
    </p>
    <e-button @click.native.prevent="$emit('confirm')">Confirmer</e-button>
    <e-button @click.native.prevent="$emit('cancel')">Annuler</e-button>
  </div>
</template>

<script>
export default {
  props: {
    versionName: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
.promptVersionDeletion {
  background-color: var(--white);
  display: inline-block;
  padding: var(--spacing-xl);
  text-align: center;
  border: 1px solid var(--black);

  p {
    margin-top: 0;
    line-height: 1.5em;
  }
}
</style>
